<template>
  <div>
    <v-col cols="12" sm="12" md="12"
      ><v-banner
        color="blue-grey lighten-5"
        class="mb-4 black--text"
        shaped
        single-line
        align="left"
      >
        Opciones
      </v-banner>
    </v-col>
    <v-row
      align="center"
      justify="center"
      class="text-center d-flex flex-wrap mb-3"
    >
      <v-col cols="12" md="4" xl="2" sm="12">
        <v-btn
          color="primary"
          small
          :outlined="!withBirads"
          :disabled="!buttonBirads || reported"
          @click="openDialog(1)"
        >
          <v-icon left>mdi-radioactive</v-icon> BI-RADS
        </v-btn>
        <div class="mt-2" v-if="$utilFront.isNonNull(model.birads) && $utilFront.nonEmpty(model.birads.name)">
          - {{ model.birads.name }} <span id="birads"></span> -
        </div>
      </v-col>
      <v-col cols="12" md="4" xl="2" sm="12"  v-if="!isMedicoInterpreteSupervisor">
        <v-btn
          color="yellow"
          small
          outlined
          @click="openDialog(2)"
          :disabled="reported"
        >
          <v-icon left>mdi-flag-outline</v-icon> Reportar estudio
        </v-btn>
      </v-col>

      <v-col cols="12" md="4" xl="2" sm="12"  v-if="!isMedicoInterpreteSupervisor">
        <v-btn
          color="red"
          small
          outlined
          @click="openDialog(3)"
          :disabled="reported"
        >
          <v-icon left>mdi-delete-empty</v-icon> Cancelar estudio
        </v-btn>
      </v-col>

      <v-col cols="12" md="12" xl="6" sm="12">
        <v-row align="baseline" justify="center">
          <v-col cols="12" md="4" xl="8" sm="12">
            <v-file-input
              accept="image/png, image/jpeg, image/jpg"
              placeholder="Seleccione la imagen"
              v-model="filesSign"
              ref="uploadFile"
              truncate-length="15"
              dense
              :disabled="reported"
              @change="validateSign()"
            ></v-file-input>
          </v-col>

          <v-col cols="12" md="4" sm="12">
            <v-btn
              color="primary"
              :disabled="invalidSign || reported"
              @click="saveSign()"
              outlined
            >
              Guardar firma
              <v-icon right>mdi-pencil-circle-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-if="dialog">
      <interpretation-report-dialog
        :modelDialog="modelDialog"
        :model="model"
        :sending="sending"
        :dialog="dialog"
        :typeDialog="typeDialog"
        :closeDialog="closeDialog"
        :listBirads="listBirads"
        :doActionDialog="doActionDialog"
      />
    </div>
  </div>
</template>
<script>
import InterpretationReportDialog from "@/app/components/interpretation/InterpretationReportDialog.vue";
import { SignRequest, StudyRequest, BiradsRequest } from "@/core/request";
export default {
  props: {
    reported: Boolean,
    withBirads: Boolean,
    buttonBirads: Boolean,
    model: Object,
    modelDialog: Object,
    // validateSign: Function,
  },
  components: {
    InterpretationReportDialog,
  },
  data() {
    return {
      filesSign: [],
      invalidSign: true,
      sending: false,
      listBirads: [],
      dialog: false,
      typeDialog: 0,
      birads: "",
    };
  },
  watch: {
    // fileTempoSign() {
    //   this.$emit('fileSign', this.fileTempoSign);
    // }
    // "modelDialog.birads": function() {
    //   console.log(this.listBirads);
    //   for (let i in this.listBirads) {
    //     if (this.listBirads[i].text == this.modelDialog.birads) {
    //       return (this.model.idBirads = this.listBirads[i].value.idBirads);
    //     }
    //   }
    //   this.birads = this.modelDialog.birads;
    // },
  },
  mounted() {
    this.listAllBirads();
    // console.log(this.model);
    this.asignBirads();
  },
  computed: {
    isMedicoInterpreteSupervisor() {
      const roleRaw = (this.$utilFront.getRole?.() || "");

      const role = roleRaw
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();

      return role === "medico interprete supervisor";
    }
  },
  methods: {
    asignBirads() {
      if (this.model.birads != null) {
        this.birads = this.model.birads;
      }
    },
    validateSign(value) {
      try {
        if (this.filesSign) {
          let formats = ["image/png", "image/jpeg", "image/jpg"];
          let typeFile = this.filesSign.type;
          let isValidFormat = formats.find((format) => {
            return typeFile == format;
          });
          if (isValidFormat) {
            this.invalidSign = false;
          } else {
            this.$utilFront.notifications(
              `Formato ${typeFile} no admitido.`,
              "ERROR"
            );
            this.filesSign = undefined;
            this.invalidSign = true;
          }
        } else {
          this.invalidSign = true;
        }
      } catch (error) {
        this.catchError(error);
      }
    },
    saveSign() {
      this.loader = true;
      try {
        this.sending = true;
        let formData = new FormData();
        formData.append("file", this.filesSign);
        SignRequest.add(formData)
          .then((res) => {
            let { data, status, code } = res.data;
            if (code == 200 && data == true) {
              this.$utilFront.notifications(
                "Firma registrada correctamente.",
                "SUCCESS"
              );
              this.filesSign = undefined;
              this.validateSign();
              this.invalidSign = true;
            } else if (code == 401) {
              this.unauthorized();
            } else if (typeof data == "string") {
              this.$utilFront.notifications(
                "Error al registrar firma.",
                "ERROR"
              );
            } else {
              this.catchError();
            }
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
            this.loader = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
    /**DIALOG BI-RADS, REPORTAR. CANCELAR */
    openDialog(typeDialog) {
      this.typeDialog = typeDialog;
      this.dialog = true;
    },
    closeDialog() {
      if (this.$refs.observerDialog != undefined) {
        this.$refs.observerDialog.reset();
      }
      // this.modelDialog = {};
      this.dialog = false;
    },
    doActionDialog() {
      if (this.typeDialog == 1) {
        this.saveBirads();
      } else if (this.typeDialog == 2) {
        this.reportStudy();
      } else if (this.typeDialog == 3) {
        this.deleteStudy();
      } else if (this.typeDialog == 4) {
        this.saveTemplate();
      } else {
        this.catchError();
      }
    },
    /**********************************/
    saveBirads() {
      
      this.dialog = false;
      // this.withBirads = true;

      let name;      
      if(this.modelDialog.birads){

        const idBiradsSelected = this.modelDialog.birads;
        const biradsSelected =  this.listBirads.find((it) => it.value == idBiradsSelected);

        if(this.model && biradsSelected){
          name = biradsSelected.name;
          const newText = `El presente estudio se categoriza como: ${biradsSelected.name}`;
          // const regex = /El presente estudio se categoriza como: BIRADS .*?/;
          // const regextTwo = /El presente estudio se categoriza como: BI-RADS .*?/;

          // const regex = /El presente estudio se categoriza como: BIRADS \w/;
          // const regextTwo = /El presente estudio se categoriza como: BI-RADS \w/;
          const regex = /El presente estudio se categoriza como: BIRADS [0-9]+[A-Za-z]?/;
          const regextTwo = /El presente estudio se categoriza como: BI-RADS [0-9]+[A-Za-z]?/;


          this.model.complement = Object.assign({}, this.model.complement);
          this.model.complement.conclusion = this.model.complement.conclusion || ''; 

         

          if (regex.test(this.model.complement.conclusion) || regextTwo.test(this.model.complement.conclusion)) {

            this.model.complement.conclusion = this.model.complement.conclusion.replace(regex, newText);
            this.model.complement.conclusion = this.model.complement.conclusion.replace(regextTwo, newText);
            this.$utilFront.notifications( `Leyenda de BI-RADS modificada en conclusión`,"WARNING"); 
           
          }else{

            this.model.complement.conclusion =  `${newText} <br/> ${this.model.complement.conclusion}` ;
            this.$utilFront.notifications( `Leyenda de ${biradsSelected.name} agregada en conclusión`,"SUCCESS"); 

          }

        }

      }

      this.model.birads = {
        name,
        note: this.modelDialog.note,
        idBirads: this.modelDialog.birads,
      };      
      this.model.note = this.modelDialog.note;
      this.model.findingLocationTypeList = this.modelDialog.findingLocationTypeList;



      this.$emit("validBiradsEmit", true);
    },
    reportStudy() {
      let data = {
        idStudy: this.model.idStudy,
        reason: this.modelDialog.reason,
      };
      StudyRequest.reportStudy(data)
        .then((res) => {
          let { data, status, code } = res.data;
          if (code == 200) {
            this.$utilFront.notifications(
              "Estudio reportado correctamente.",
              "SUCCESS"
            );
            // this.disabledButton();
            this.dialog = false;
            this.$emit("ReportedValue", true);
          } else if (code == 401) {
            this.unauthorized();
          } else if (typeof data == "string") {
            this.$utilFront.notifications(data, "ERROR");
          } else {
            this.catchError();
          }
        })
        .catch(this.catchError)
        .finally(() => {});
    },
    deleteStudy() {
      let data = {
        idStudy: this.model.idStudy,
        reason: this.modelDialog.reason,
      };
      StudyRequest.discardStudy(data)
        .then((res) => {
          let { data, status, code } = res.data;
          if (code == 200) {
            this.$utilFront.notifications(
              "Estudio cancelado correctamente.",
              "SUCCESS"
            );
            this.dialog = false;
            this.$emit("ReportedValue", true);
            // this.disabledButton();
          } else if (code == 401) {
            this.unauthorized();
          } else if (typeof data == "string") {
            this.$utilFront.notifications(
              "Error al cancelar estudio.",
              "ERROR"
            );
          } else {
            // this.catchError();
          }
        })
        .catch(this.catchError)
        .finally(() => {});
    },
    listAllBirads() {
      BiradsRequest.listAll()
        .then((res) => {
          let { data, status, code } = res.data;
          if (code == 200 && Array.isArray(data)) {
            this.listBirads = data.map((obj) => {
              return {
                value: obj.idBirads,
                name: obj.name,
                color: obj.color,
              };
            });
          } else if (code == 401) {
            this.unauthorized();
          }
        })
        .catch(this.catchError)
        .finally(() => {});
    },
    getBiradsText(idBirads) {
      let biradsText = "N/D";
      if (this.$utilFront.nonEmpty(idBirads)) {
        biradsText =
          this.listBirads.find((it) => it.value == idBirads)?.name ||
          biradsText;
      }
      return biradsText;
    },
  },
};
</script>

<style></style>
